module.exports = __webpack_public_path__ + "static/media/metroprov.b661c255.png";